import React, { useState, useImperativeHandle, forwardRef } from "react";
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import check_afm1 from '../../img/check_afm1.png';
import check_afm2 from '../../img/check_afm2.png';
import check_afm3 from '../../img/check_afm3.png';

const MyDataCheckAfmHelpModal = forwardRef((_props, ref) => {
    const { t } = useTranslation();
    const [show, setShow] = useState(false);

    useImperativeHandle(ref, () => ({
        open: () => setShow(true),
        close: () => setShow(false),
    }));

    const steps = [
        { text: t('checkAfmHelpStep1'), img: check_afm1 },
        { text: t('checkAfmHelpStep2'), img: check_afm2 },
        { text: null, img: check_afm3 },
    ];

    return (
        <Modal
            size="xl"
            centered
            scrollable
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton className="mydata-help-modal-header">
                <Modal.Title>
                    <i className="fa fa-search" style={{ marginRight: 10 }}></i>
                    {t('checkAfmHelpTitle')}
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="mydata-help-modal-body">
                {steps.map((step, i) => (
                    <div key={i} className="mydata-help-step mb-3">
                        {step.text && (
                            <div className="mydata-help-step-header">
                                <span className="mydata-help-step-number">{i + 1}</span>
                                <span className="mydata-help-step-text">{step.text}</span>
                            </div>
                        )}
                        <div className="mydata-help-step-img">
                            <img src={step.img} alt={`step-${i + 1}`} style={{ width: '60%', maxWidth: '100%', display: 'block', margin: '0 auto' }} />
                        </div>
                    </div>
                ))}
            </Modal.Body>

            <Modal.Footer>
                <button className="btn btn-skin" onClick={() => setShow(false)}>OK</button>
            </Modal.Footer>
        </Modal>
    );
});

export default MyDataCheckAfmHelpModal;
